import { render, staticRenderFns } from "./ImportantMessages.vue?vue&type=template&id=6519e443"
import script from "./ImportantMessages.vue?vue&type=script&lang=js"
export * from "./ImportantMessages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports